






















































































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import moment from "moment";
import { ShiftBidWithSchedule } from "@/api";

@Component
export default class OpenShiftsTab extends Vue {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Prop({ default: () => [] }) openShifts!: any[];
  @Prop({ default: false }) isActive!: boolean;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  selectedShift: any = null;
  loadingBids = false;
  approvingBidId: number | null = null;

  get shiftBids(): ShiftBidWithSchedule[] {
    return this.$store.getters["schedule/shiftBids"] || [];
  }

  get hasApprovedBid(): boolean {
    return this.shiftBids.some(bid => bid.status === "APPROVED");
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  isSelected(shift: any): boolean {
    return !!this.selectedShift && this.selectedShift.id === shift.id;
  }

  formatDate(dateStr: string) {
    const d = moment(dateStr);
    if (d.isSame(moment(), "day")) return "Today";
    if (d.isSame(moment().add(1, "day"), "day")) return "Tomorrow";
    return d.format("ddd, MMM D");
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  async openShiftDetails(shift: any) {
    this.selectedShift = shift;
    this.loadingBids = true;
    try {
      await this.$store.dispatch("schedule/fetchShiftBids", shift.id);
    } catch (error) {
      console.error("Failed to fetch shift bids:", error);
    } finally {
      this.loadingBids = false;
    }
  }

  async approveBid(bid: ShiftBidWithSchedule) {
    if (!this.selectedShift || this.hasApprovedBid) return;
    this.approvingBidId = bid.id;
    try {
      await this.$store.dispatch("schedule/updateShiftBidStatus", {
        scheduleId: bid.scheduleId,
        shiftBid: {
          ...bid,
          bidder: bid.bidder.id,
          status: "APPROVED",
        },
      });
      await this.$store.dispatch(
        "schedule/fetchShiftBids",
        this.selectedShift.id,
      );
      this.$emit("fetchShift");
    } catch (error) {
      console.error("Failed to approve shift bid:", error);
    } finally {
      this.approvingBidId = null;
    }
  }

  @Watch("$store.state.schedule.lastSocketUpdate")
  onSocketRefresh() {
    if (this.isActive && this.selectedShift) {
      this.$store.dispatch("schedule/fetchShiftBids", this.selectedShift.id);
    }
  }

  getStatusColor(status: string) {
    switch (status) {
      case "APPROVED":
        return "success";
      case "DENIED":
      case "REJECTED":
        return "error";
      case "PENDING":
        return "warning";
      default:
        return "grey";
    }
  }
}
